// Copyright (c) 2020-2023 dātma, inc™
//
// Unauthorized copying of this file, via any medium is strictly prohibited
// Proprietary and confidential
function getEnv(name) {
  return window?.configs?.[name] || process.env[name]
}

// Versioning
export const githubSHA = getEnv('GITHUB_SHA')
export const bitbucketBuildNumber = getEnv('VUE_APP_BITBUCKET_BUILD_NUMBER')
export const bitbucketCommit = getEnv('VUE_APP_BITBUCKET_COMMIT')
export const productVersionSemver = getEnv('VUE_APP_PRODUCT_VERSION_SEMVER')

// Pubsub Configs
export const pubsubHost = getEnv('VUE_APP_PUBSUB_HOST')
export const pubsubPort = getEnv('VUE_APP_PUBSUB_PORT')
export const sessionChannelKey = getEnv('VUE_APP_PUBSUB_SESSION_CHANNEL_KEY')
export const rpcChannelKey = getEnv('VUE_APP_PUBSUB_RPC_CHANNEL_KEY')
export const userChannelKey = getEnv('VUE_APP_PUBSUB_USER_CHANNEL_KEY')
export const presenceChannelKey = getEnv('VUE_APP_PUBSUB_PRESENCE_CHANNEL_KEY')

// Feature Flags
export const noBackend = getEnv('VUE_APP_NO_BACKEND') === 'true'
export const providenceBuild = getEnv('VUE_APP_PROVIDENCE_BUILD') === 'true'
export const upennBuild = getEnv('VUE_APP_UPENN_BUILD') === 'true'
export const guardantBuild = getEnv('VUE_APP_GUARDANT_BUILD') === 'true'
export const isUx3 = getEnv('VUE_APP_UX3') === 'true'
export const productFocus = getEnv('VUE_APP_PRODUCT_FOCUS')
export const chooseAdditionalThemes = getEnv('VUE_APP_CHOOSE_ADDITIONAL_THEMES') === 'true'
export const dashboardMultiSessionSelect = getEnv('VUE_APP_DASHBOARD_MULTI_SESSION_SELECT') === 'true'
export const enableSessionReadOnlySharing = getEnv('VUE_APP_ENABLE_SESSION_READ_ONLY_SHARING') === 'true'
export const enableSessionSharing = getEnv('VUE_APP_ENABLE_SESSION_SHARING') === 'true'
export const noProfile = getEnv('VUE_APP_NO_PROFILE') === 'true'

// Feature Flags UX3
export const useDiagnosisWithTreatmentsTrialsRequests = getEnv('VUE_APP_UX3_USE_DIAGNOSIS_WITH_TREATMENTS_TRIALS_REQUESTS') === 'true'
export const useNewOmicsApi = getEnv('VUE_APP_UX3_USE_NEW_OMICS_API') === 'true'
export const enableAdvancedTrialSearch = getEnv('VUE_APP_UX3_ENABLE_ADVANCED_TRIALS_SEARCH') === 'true'

// Keycloak Settings
export const keycloakBaseUrl = getEnv('VUE_APP_KEYCLOAK_BASE_URL')
export const keycloakClientId = getEnv('VUE_APP_KEYCLOAK_CLIENT_ID')
export const keycloakClientSecret = getEnv('VUE_APP_KEYCLOAK_CLIENT_SECRET')
export const keycloakEhrLaunchIdp = getEnv('VUE_APP_KEYCLOAK_EHR_LAUNCH_IDP')
export const sessionTimeoutCheckSeconds = getEnv('VUE_APP_SESSION_CHECK_SECONDS') || 5

// Miscellanous Settings
export const baseUrl = getEnv('BASE_URL')
export const logoutAfterInactivityMinutes = getEnv('VUE_APP_LOGOUT_AFTER_INACTIVITY_MINUTES') || 0
export const requestTimeout = getEnv('VUE_APP_REQUEST_TIMEOUT_MS') || 15000 // 15000 ms = 15 seconds
export const defaultToolTimeout = getEnv('VUE_APP_TOOL_TIMEOUT_MS') || 15000
export const fileSizeLimit = getEnv('VUE_APP_FILE_SIZE_LIMIT') || 35000000

// Pathology Urls
export const pathdsRoute = getEnv('VUE_APP_PATHDS_URL') || '/pathds/'
export const pathologyViewerRoute = getEnv('VUE_APP_PATHOLOGY_VIEWER_ROUTE') || '/pathds/viewer/v1/mypatient'

// EHR Urls
export const ehrBaseUrl = getEnv('VUE_APP_EHR_URL') || '/ehr'
export const ehrCrudUrl = getEnv('VUE_APP_EHR_CRUD_URL') || '/ehr_crud/api/v1'
export const searchBaseUrl = getEnv('VUE_APP_PATIENT_SEARCH_BASE_URL') || `${ehrBaseUrl}/patient_search_v3/`

// Clinical Timeline Urls
export const clinicalTimelineBaseUrl = getEnv('VUE_APP_CLINICAL_TIMELINE_BASE_URL') || '/timeline'

// Omics and Annotation Urls
export const omicsBaseUrl = getEnv('VUE_APP_OMICS_DS_BASE_URL') || '/omicsdsREST'
export const omicsFastUrl = getEnv('VUE_APP_OMICS_DS_FAST_URL') || '/omicsds/api/v1'
export const annotationBaseUrl = getEnv('VUE_APP_VEP_ANNOTATION_BASE_URL') || '/oda_annotation'
export const biomarkerBaseUrl = getEnv('VUE_APP_BIOMARKER_BASE_URL') || '/getBiomarkerREST'
export const defaultPostalCode = getEnv('VUE_APP_POSTAL_CODE') || '97005'
export const advancedSearchUrl = getEnv('VUE_APP_UX3_ADVANCED_TRIALS_SEARCH_URL') || 'https://app.molecularmatch.com'

// Tumor Board Schedular Urls
export const tumorBoardBaseUrl = getEnv('VUE_APP_TUMOR_BOARD_BASE_URL') || '/tumor_board'
export const tumorBoardBlackBoxUrl = `${tumorBoardBaseUrl}/mypatient/v1/`

// Radiology Urls
export const radiologyViewerUrl = getEnv('VUE_APP_RADIOLOGY_VIEWER_URL') || ''

// Accession Number Regex Pattern
export const accessionNumberRegex = new RegExp(getEnv('VUE_APP_ACCESSION_NUMBER_REGEX_PATTERN') || '^.*(PRV|RFV)$')

export default {}
